import axios from 'axios'
import { TEST_URl } from '@/utils/constants.js'

const defaultBaseUrl = `${process.env.VUE_APP_BASE_URL}`
const testUrl = localStorage.getItem(TEST_URl)
const baseUrl = testUrl || defaultBaseUrl

export async function getCurrentAccountService (currency) {
  const res = await axios.get(`${baseUrl}/account/${currency}`)
  return res
}
export async function depositAgreementService () {
  const res = await axios.get(`${baseUrl}/deposits/agreement`)
  return res
}
export async function getPlaidAccountsService () {
  const res = await axios.get(`${baseUrl}/deposits/ach/account`)
  return res
}
export async function initiateDepositService (userData) {
  const res = await axios.post(`${baseUrl}/deposits/initiate`, { ...userData })
  return res
}
export async function initiateLocalDepositService (userData) {
  const res = await axios.post(`${baseUrl}/deposits/initiate/local`, {
    ...userData
  })
  return res
}
export async function getTransactionsService (payload) {
  const sortDirection =
    payload?.sort_direction_desc !== undefined
      ? payload.sort_direction_desc
      : true
  const currency = payload.currency ? payload.currency : ''
  const payment_method = payload.payment_method ? payload.payment_method : ''
  const res = await axios.get(
    `${baseUrl}/transactions?page=${payload.page}&size=${
      payload.size
    }&sort_by=${
      payload.sort_by || 'created_at'
    }&sort_direction_desc=${sortDirection}&status=${payload.status}&from=${
      payload.from
    }&to=${payload.to}&type=${
      payload.type
    }&currency=${currency}&payment_method=${payment_method}`
  )
  return res
}
export async function getDepositsService (payload) {
  const hasReason = payload.reason ? `&reason=${payload.reason}` : ''
  const res = await axios.get(
    `${baseUrl}/deposits?page=${payload.page}&size=${payload.size}&sort_by=created_at&sort_direction_desc=true&status=${payload.status}&from=${payload.from}&to=${payload.to}&type=${payload.type}${hasReason}`
  )
  return res
}
export async function getTransactionService (payload) {
  const res = await axios.get(
    `${baseUrl}/transactions/${payload.transactionType}/${payload.transactionId}`
  )
  return res
}
export async function initiateAchDepositService (payload) {
  const res = await axios.post(`${baseUrl}/deposits/ach/link-token`, {
    ...payload
  })
  return res
}
export async function plaidDepositService (payload) {
  const res = await axios.post(`${baseUrl}/deposits/ach`, { ...payload })
  return res
}
export async function generateTokenService (payload) {
  const res = await axios.post(`${baseUrl}/deposits/ach/access-token`, {
    ...payload
  })
  return res
}
export async function getWalletAddressesService (payload) {
  const url = payload
    ? `?reason=${payload.reason}&network=${payload.network}&asset=${payload.asset}`
    : ''
  const res = await axios.get(`${baseUrl}/account/wallets${url}`)
  return res
}
export async function initiateSwapFundsService (payload) {
  const res = await axios.post(`${baseUrl}/transactions/swap-currency`, {
    ...payload
  })
  return res
}
export async function generateVirtualAccountService (payload) {
  const res = await axios.post(`${baseUrl}/account/virtual-account/request`, {
    ...payload
  })
  return res
}
export async function getGBPAccountsService () {
  const res = await axios.get(`${baseUrl}/account/GBP`)
  return res
}
export async function getVirtualAccountRequestsService (status) {
  const statusParam = status ? `?status=${status}` : ''
  const res = await axios.get(
    `${baseUrl}/account/virtual-account/requests${statusParam}`
  )
  return res
}
export async function getVirtualAccountOpeningsService (status) {
  const statusParam = status ? `?status=${status}` : ''
  const res = await axios.get(
    `${baseUrl}/account/virtual-account/openings${statusParam}`
  )
  return res
}

export async function getTransactionReportService (payload) {
  const fileTypeParam = payload.reportFileType
    ? `&fileType=${payload.reportFileType}`
    : ''
  const res = await axios.get(
    `${baseUrl}/transactions/download?from=${payload.from}&to=${payload.to}${fileTypeParam}`
  )
  return res
}

export async function getReceiptDetailsService (payload) {
  const res = await axios.get(`${baseUrl}/transactions/receipt/${payload.id}`)
  return res
}
